"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacementEntityIdentifierEnum = void 0;
var PlacementEntityIdentifierEnum;
(function (PlacementEntityIdentifierEnum) {
    PlacementEntityIdentifierEnum["SEARCH_KBA"] = "8bff0282-f639-4aa1-94b8-5531f34c0c55";
})(PlacementEntityIdentifierEnum || (exports.PlacementEntityIdentifierEnum = PlacementEntityIdentifierEnum = {}));
